/**
 * The social.js uses the social texts specified in the config
 * and inserts them into the social buttons in the header
 */

import $ from 'jquery';
const config = ARTICLE_CONFIG;

let url;

function init() {
  url = encodeURIComponent(config.meta.ogUrl);
  updateButtons();
}

function updateButtons(){
  whatsapp();
  facebook();
  twitter();
}

function whatsapp() {
  const href = 'whatsapp://send?text=' + config.social.whatsapp.replace('{{url}}', url);
  $('.wa-btn').attr('href', href);
}

function facebook() {
  const iframeSrc = `https://www.facebook.com/plugins/like.php?href=${url}&width&layout=button_count&action=like&show_faces=false&share=false&height=80&locale=de_DE`;
  $('.fb-iframe').attr('src', iframeSrc);

  $('.btn-facebook').attr('href', getFbLink());
}

function twitter() {
  $('.btn-twitter').attr('href', getTwitterLink());
}

function getFbLink() {
  return `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${encodeURIComponent(config.social.facebook).replace('%7B%7Burl%7D%7D', url)}`;
}

function getTwitterLink() {
  return `https://twitter.com/intent/tweet?source=${url}&text=${encodeURIComponent(config.social.twitter).replace('%7B%7Burl%7D%7D', url)}`;
}

export default {
  init,
  getFbLink,
  getTwitterLink
};
